import { render, staticRenderFns } from "./LiffPageConfigTreeEditor.vue?vue&type=template&id=031c8668&scoped=true&"
import script from "./LiffPageConfigTreeEditor.vue?vue&type=script&lang=js&"
export * from "./LiffPageConfigTreeEditor.vue?vue&type=script&lang=js&"
import style0 from "./LiffPageConfigTreeEditor.vue?vue&type=style&index=0&id=031c8668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c8668",
  null
  
)

export default component.exports